var map = {
	"./21_scared.mp3": "6f29",
	"./36_sing.mp3": "746e",
	"./37_catch.mp3": "0644",
	"./38_clap.mp3": "b5d5",
	"./40_run.mp3": "f041",
	"./41_paint.mp3": "a3e0",
	"./42_jump.mp3": "7f23",
	"./click.mp3": "9924",
	"./empty_true.mp3": "d2d5",
	"./false.mp3": "440a",
	"./true.mp3": "a594"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fba2";